module.exports = __webpack_public_path__ + "a89ba25d96ea7a4ff8794cf524f8c7f4.svg";